
export default function CustomButton ({
    type,
    color,
    text,
    className
  }) {
  return (
    <button type={type} className={`btn btn-outline-${color} btn-show-shadow has-inner-text ${className}`}>
      <div className={`multi-colored-${color}-shadow-hover-only`}></div>
      <div className={`btn-inner-text text-glow-${color} hover:text-white transition-all`}>{text}</div>
    </button>
  )
}

